<template>
  <div class="job" v-if="data" @click="showDetails(data)">
    <div class="title">{{data.title}}</div>
    <div class="date">&nbsp;<!--{{formatDate(data.lastUpdate)}}--></div>
    <div class="spacer"></div>
    <div class="details">
      <div class="left">{{getLocation(data.location)}} | {{data.jobFamily}}</div>
      <div class="right">{{data.contractType}}</div>
    </div>
  </div>
</template>

<script>
import { getLabel } from "../services/labels.js";
import moment from "moment";

export default {
  name: 'Posting',
  props: ["data"],
  components: {
    
  },
  methods: {
    formatDate (date) {
      return moment(date).format("LL");
    },
    getLocation (loc) {
      if (loc === "All, All, All") return getLabel("locationGlobal");
      else return loc;
    },
    showDetails (data) {
      this.$emit("click", data);
    }
  }
}
</script>

<style scoped>
.job {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  outline: 1px solid #d4d4d4;
  display: flex;
  flex-direction: column;
}

.job:hover {
  outline: 1px solid black;
}

.title {
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  text-transform: uppercase;
  word-break: break-word;
}

.date {
  font-size: 14px;
  margin-bottom: 20px;
}

.spacer {
  flex-grow: 1;
}

.details {
  display: flex;
}

.details .left {
  flex-grow: 1;
}

.job .details .right {
  display: block;
}

@media all and (max-width:960px) {
  .details {
    flex-direction: column;
  }
  .job .details .right {
    display: block;
  }
}
</style>